import { Box, Card, CardContent, Stack } from "@mui/material";
import React, { useState } from "react";
import CardTitle from "./CardTitle";
import MiniField from "./MiniField";
import { useDispatch, useSelector } from "react-redux";
import { updateDataFilterSetting } from "../../reducer/CalcSettingsSlice";
import { DataFilterTypes } from "../../common/common";

export default function NoiseReductionCard(props) {
    const laserData = useSelector(state => state.laserData);
    const calcSettings = useSelector(state => state.calcSettings);
    const nrSettings = calcSettings.changes.dataFilters.find(df => df.type === DataFilterTypes.NoiseReduction); // 0 is the noise reduction filter
    const [toleranceError, setToleranceError] = useState(false);
    const dispatch = useDispatch();

    const handleToleranceChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            let error = (evt.target.value.length === 0) || (Number(evt.target.value) === 0);
            setToleranceError(error);
            dispatch(updateDataFilterSetting({
                type: DataFilterTypes.NoiseReduction,
                property: "Tolerance",
                value: evt.target.value,
                error: error
            }));
        }
    }

    const getTraceValue = (prop) => {
        try {
            let filter = laserData.filterTrace.filters.find(f => f.type === "NoiseReduction");
            if(filter) {
                return filter.trace[prop];
            } else {
                return -1;
            }
        } catch (err) {
            console.log(err);
            return -1;
        }
    }

    const pointsRemoved = () => {
        let initial = getTraceValue("initialpointcount");
        let reduced = getTraceValue("reducedpointcount");

        if(initial > -1 && reduced > -1) {
            return (
                <>
                    <Box sx={{paddingTop: "5px"}}>
                        <label>Initial Points: <b>{initial}</b></label>
                    </Box>
                    <Box>
                        <label>Points Removed: <b>{initial - reduced}</b></label>
                    </Box>
                    <Box>
                        <label>Remaining Points: <b>{reduced}</b></label>
                    </Box>
                </>
            )
        } else {
            return <></>
        }
    }

    const renderAttributes = () => {
        return (
            <>
                <Stack direction="row" spacing={1}>
                    <Box>
                        <MiniField
                            label="Tolerance (µm)"
                            value={nrSettings.attributes.Tolerance}
                            onChange={handleToleranceChange}
                            maxLength={6}
                            error={toleranceError}
                        />
                    </Box>
                    <Box>
                        {pointsRemoved()}
                    </Box>
                </Stack>
            </>
        );
    }
    return (
        <Card variant="outlined">
            <CardContent>
                <CardTitle title="Noise Reduction" />
                {
                (nrSettings === 0) ? (
                    renderAttributes()
                ) : 
                ("Not applied")
                }
            </CardContent>
        </Card>
    )
}